import { render } from "./wasteScanner.vue?vue&type=template&id=6b6720b5&scoped=true"
import script from "./wasteScanner.vue?vue&type=script&lang=js"
export * from "./wasteScanner.vue?vue&type=script&lang=js"

import "./wasteScanner.vue?vue&type=style&index=0&id=6b6720b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6720b5"]])

export default __exports__